module.exports = function getResource(label, vars = []) {
    const resources = {
        extraText: vars[0] ? ' Tous' : '',
        buttonText: vars[0] ? vars[1] ? `Retirer des favoris${vars[2]}` : `Favoris${vars[2]}` : `Ajouter${vars[2]} aux favoris`
    };

    return resources[label];
};
